<template>
  <div class="journey-edit" @scroll="handleScroll" ref="journeyEdit">
    <div class="sticky">
      <div class="edit-stage">
        <div class="stage-div">
          <div class="stage-num">{{ codeTxt.substring(0, 2) }}</div>
          <div class="stage-title">{{ stageTxt }}</div>
        </div>
        <div class="submit-btn" @click="handleSubmit">保存</div>
      </div>
      <div class="flex-div">
        <div class="flex-nav">
          <!-- 成长周期 tab -->
          <span v-if="isShowGrowthCycle" class="nav-txt" :class="{ cur: activeTab === 'growth-cycle' }"
            @click="scrollToSection('growth-cycle')">
            成长周期
          </span>
          <!-- iEP学习 tab -->
          <span class="nav-txt" :class="{ cur: (activeTab === 'iep-course' || !isShowGrowthCycle) }"
            @click="scrollToSection('iep-course')">
            iEP学习
          </span>
        </div>
      </div>
    </div>
    <div id="growth-cycle" v-if="isShowGrowthCycle" class="div-con">
      <div class="title">成长周期</div>
      <div class="cons">
        <div class="label">周期选择</div>
        <div class="val">
          <van-stepper v-model="stepVal" :disabled="!isShowGrowthCycle" />
          <span class="unit">M</span>
        </div>
      </div>
    </div>
    <div id="iep-course" class="div-con">
      <div class="title">iEP学习</div>
      <input type="text" placeholder="点击选择课程/病例/文献" class="course-input" readonly @click="handleClickJump('course')" />
      <div class="tip">已选择课程/病例/文献</div>
      <div class="list-act">
        <div class="item" v-for="(item_check, key_check) in studyContent" :key="key_check">
          <img src="@/assets/images/cartojourney/img19.png" @click="handleDel('course', key_check)" class="icon-del"
            alt="">
          <img :src="item_check.docuCourseCase ? item_check.docuCourseCase.coverUrl : ''" class="item-cover course-cover" alt="" />
          <div class="item-cons">
            <div class="cons-name">{{ item_check.docuCourseCase ? item_check.docuCourseCase.title : '' }}</div>
            <div class="cons-flex">
              <div class="flex-times" v-if="item_check.baseType != 1">讲师: {{ item_check.docuCourseCase ? item_check.docuCourseCase.keynoteSpeaker : '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/util'
import { customizedChangeCycle, customizedChangeStudyContent } from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      value: 1,
      activeTab: 'growth-cycle',
      sections: ['growth-cycle', 'iep-course'],
      sectionPositions: {},
      stepVal: 0,
      studyContent: [],
      selectCycle: {},
      codeTxt: '',
      stageTxt: '',
      isSurgeon: false
    }
  },
  computed: {
    userRole () {
      return sessionStorage.getItem('userRole')
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    isShowGrowthCycle() {
      return this.customizedMultiCode === this.userInfo.multiCode || !this.isSurgeon
    }
  },
  mounted () {
    this.studyContent = JSON.parse(sessionStorage.getItem('selectCourse'))
    this.selectCycle = JSON.parse(sessionStorage.getItem('selectCycle'))
    this.customizedCode = this.$route.query.customizedCode
    this.customizedJourneyId = this.$route.query.customizedJourneyId
    this.customizedStageId = this.$route.query.customizedStageId
    this.customizedMultiCode = this.$route.query.customizedMultiCode
    this.codeTxt = this.$route.query.codeTxt
    this.stageTxt = this.$route.query.stageTxt
    this.isSurgeon = this.$route.query.isSurgeon ? JSON.parse(this.$route.query.isSurgeon) : false
    this.updateSectionPositions()
    window.addEventListener('resize', this.updateSectionPositions)
    this.stepVal = this.selectCycle ? this.selectCycle.growthCycle : 1
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateSectionPositions)
  },
  methods: {
    handleDel (type, index) {
      if (type === 'course') {
        this.studyContent.splice(index, 1)
        sessionStorage.setItem('selectCourse', JSON.stringify(this.studyContent))
      }
    },
    updateCustomization (key, value, apiMethod) {
      const params = {
        customizedId: this.customizedCode,
        journeyId: this.customizedJourneyId,
        stageId: this.customizedStageId,
        [key]: value
      }
      apiMethod(params).then(res => {
        console.log(res)
      })
    },
    handleSubmit: debounce(function () {
      // 1文献 2课程 3病例
      this.updateCustomization('classContent', this.studyContent.map(res => {
        return {
          baseType: res.baseType,
          baseId: res.courseId
        }
      }), customizedChangeStudyContent)
      if (!this.isSurgeon || this.isShowGrowthCycle) {
        this.updateCustomization('growthCycle', this.stepVal, customizedChangeCycle)
      }
      sessionStorage.removeItem('journeyStage')
      this.$router.go(-1)
    }, 500),
    handleChangeStep (e) {
      if (e <= 1) {
        this.stepVal = 1
      }
      let params = {
        'customizedId': this.customizedCode,
        'journeyId': this.customizedJourneyId,
        'stageId': this.customizedStageId,
        'growthCycle': this.stepVal
      }
      customizedChangeCycle(params).then(res => {
        console.log(res)
      })
    },
    handleClickJump (type) {
      if (type === 'course') {
        this.$router.push({
          path: '/selectCourse',
          query: {
            customizedCode: this.customizedCode,
            customizedJourneyId: this.customizedJourneyId,
            customizedStageId: this.customizedStageId
          }
        })
      }
    },
    handleScroll () {
      const scrollTop = this.$refs.journeyEdit.scrollTop
      let newActiveTab = this.activeTab
      for (let i = 0; i < this.sections.length; i++) {
        if (
          scrollTop >= this.sectionPositions[this.sections[i]] &&
          (!this.sectionPositions[this.sections[i + 1]] ||
            scrollTop < this.sectionPositions[this.sections[i + 1]])
        ) {
          newActiveTab = this.sections[i]
          break
        }
      }
      if (newActiveTab !== this.activeTab) {
        this.activeTab = newActiveTab
      }
    },
    updateSectionPositions () {
      this.sections.forEach(sectionId => {
        const element = document.getElementById(sectionId)
        if (element) {
          this.sectionPositions[sectionId] = element.offsetTop - 128
        }
      })
    },
    scrollToSection (sectionId) {
      if (this.isSurgeon) return
      this.activeTab = sectionId
      const element = document.getElementById(sectionId)
      if (element) {
        this.$refs.journeyEdit.scrollTo({
          top: element.offsetTop - 128,
          behavior: 'smooth'
        })
      }
    }
  }
}
export default withRouteTracking(UserProfile)

</script>

<style lang="less" scoped>
.journey-edit {
  background: #F9F8F7;
  height: 100vh;
  overflow: auto;

  .sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1000;
    background-image: url('../../assets/images/cartojourney/img01.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: #F9F8F7;
  }

  .edit-stage {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding: 0 12px;
    box-sizing: border-box;
    position: relative;

    .stage-div {
      display: flex;
      align-items: center;

      .stage-num {
        margin-right: 6px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: radial-gradient(circle at 32% 75%,
            #ff8274 0%,
            #eb1700 54%,
            #ffa69d 100%);
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-weight: 500;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
      }

      .stage-title {
        font-size: 16px;
        font-weight: 500;
        color: #000;
      }
    }

    .submit-btn {
      width: 58px;
      text-align: center;
      line-height: 28px;
      background-color: #eb1700;
      border-radius: 100px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .flex-div {
    position: relative;

    .flex-nav {
      display: flex;
      align-items: center;
      height: 42px;

      .nav-txt {
        display: block;
        text-align: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
        color: #333333;
        flex: 1;
        cursor: pointer; // 设置鼠标悬停时显示为可点击状态

        &.cur {
          font-weight: 600;
          color: #eb1700;
          position: relative;
          height: 42px;
          line-height: 42px;

          &::after {
            position: absolute;
            bottom: 4px;
            left: 50%;
            transform: translateX(-50%);
            content: '';
            width: 23px;
            height: 9px;
            background-image: url('../../assets/images/cartojourney/img18.png');
            background-repeat: no-repeat;
            background-size: 100%;
          }
        }
      }
    }
  }

  .div-con {
    background-color: #fff;
    border-radius: 12px;
    padding: 10px 12px;
    box-sizing: border-box;
    position: relative;
    margin: 12px 10px;

    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #282828;
      line-height: 20px;
      position: relative;
      display: inline-block;

    }

    .cons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 18px;
      padding-bottom: 10px;

      .label {
        font-family: PingFang HK, PingFang HK;
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
      }

      .val {
        display: flex;
        align-items: center;

        .unit {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 14px;
          color: #282828;
          margin-left: 6px;
        }
      }
    }

    .course-input {
      display: block;
      width: 100%;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      height: 40px;
      box-sizing: border-box;
      font-family: PingFang HK, PingFang HK;
      font-size: 14px;
      padding-left: 16px;
      outline: none;
      margin-top: 24px;
      margin-bottom: 12px;
    }

    .tip {
      font-family: PingFang HK, PingFang HK;
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
    }

    .list-act {
      .item {
        display: flex;
        padding: 8px 10px;
        box-sizing: border-box;
        background-color: #F5F6F9;
        border-radius: 4px;
        margin-top: 8px;
        position: relative;

        &.item-act {
          align-items: center;

          .item-cons {
            .cons-name {
              margin-bottom: 0;
            }
          }
        }

        .icon-del {
          width: 13px;
          height: 13px;
          position: absolute;
          right: 1px;
          top: 1px;
        }

        .item-cover {
          width: 32px;
          height: 32px;
          display: block;
          margin-right: 4px;

          &.course-cover {
            width: 116px;
            height: 68px;
            object-fit: cover;
            border-radius: 4px;
          }
        }

        .item-cons {
          display: flex;
          flex-direction: column;
          flex: 1;

          .cons-name {
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            margin-bottom: 6px;
            display: -webkit-box;
            /* 盒子类型 */
            word-break: break-all;
            /* 自动换行的处理方法。允许在单词内换行 */
            text-overflow: ellipsis;
            /* 溢出时用... */
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;

          }

          .cons-flex {
            display: flex;
            justify-content: space-between;
            flex: 1;
            height: 20px;

            .flex-times {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-size: 13px;
              color: #b1b1b1;
            }

            .status {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-size: 12px;
              color: #eb1700;

              &.none {
                background-color: #eb1700;
                color: #fff;
                text-align: center;
                width: 46px;
                border-radius: 100px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/journeyEdit.vue